import { render } from "./PacsPopup.vue?vue&type=template&id=6e824df1&scoped=true&ts=true"
import script from "./PacsPopup.vue?vue&type=script&lang=ts"
export * from "./PacsPopup.vue?vue&type=script&lang=ts"

import "./PacsPopup.vue?vue&type=style&index=0&id=6e824df1&scoped=true&lang=css"
import "./PacsPopup.vue?vue&type=style&index=1&id=6e824df1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e824df1"]])

export default __exports__